// Audience role slugs come from the documentation API; known ones get display labels
const ROLE_LABELS = {
  mitarbeiter: 'Mitarbeiter',
  projektleitung: 'Projektleitung',
  buchhaltung: 'Buchhaltung',
  admin: 'Administration',
};

export const labelForRole = (role) =>
  ROLE_LABELS[role] || role.charAt(0).toUpperCase() + role.slice(1);

// Stable ordering: known roles first, unknown ones appended alphabetically
export const sortRoles = (roles) => {
  const known = Object.keys(ROLE_LABELS);
  return [...roles].sort((a, b) => {
    const ia = known.indexOf(a);
    const ib = known.indexOf(b);
    if (ia === -1 && ib === -1) return a.localeCompare(b);
    if (ia === -1) return 1;
    if (ib === -1) return -1;
    return ia - ib;
  });
};
